import type { ChangeEvent } from "react";
import type {
  FieldValues,
  Path,
  PathValue,
  UseFormReturn,
} from "react-hook-form";
import TextArea from "../core/textarea.core";

interface PrefixTextAreaProps<T extends FieldValues> {
  prefix: string;
  form: UseFormReturn<T>;
  name: Path<T>;
  label: string;
  placeholder?: string;
  required?: boolean;
  rows?: number;
}

const PrefixTextArea = <T extends FieldValues>({
  prefix,
  form,
  name,
  label,
  placeholder,
  required = false,
  rows = 5,
}: PrefixTextAreaProps<T>) => {
  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;

    const formattedText = value
      .split(" ")
      .map((word) =>
        word.startsWith(prefix ? prefix : "") || word === ""
          ? word
          : `${prefix}${word}`
      )
      .join(" ");

    form.setValue(name, formattedText as PathValue<T, Path<T>>, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
  };

  return (
    <TextArea
      label={label}
      placeholder={placeholder}
      value={(form.watch(name) as string) || ""}
      onChange={handleChange}
      error={form.formState.errors[name]?.message as string}
      fullWidth
      rows={rows}
      required={required}
    />
  );
};

export default PrefixTextArea;
